import { render, staticRenderFns } from "./BottomDevice.vue?vue&type=template&id=090f6334&scoped=true"
import script from "./BottomDevice.vue?vue&type=script&lang=js"
export * from "./BottomDevice.vue?vue&type=script&lang=js"
import style0 from "./BottomDevice.vue?vue&type=style&index=0&id=090f6334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090f6334",
  null
  
)

export default component.exports